export const getPaymentLink = (invoiceId: string) => {
  return `${process.env.NEXT_PUBLIC_BUILD_MARKETPLACE_BASE_URL}/payments/${invoiceId}`;
};
